import { ForwardedRef, forwardRef } from 'react';
import { RadioGroupProps as MuiRadioGroupProps } from '@mui/material/RadioGroup';
import { MuiRadioGroup } from '../../../../../modules/material';
import FormFieldWrapper, { FormFieldWrapperProps } from '../FormFieldWrapper';

export interface RadioGroupProps
  extends MuiRadioGroupProps,
    Pick<
      FormFieldWrapperProps,
      | 'label'
      | 'helperText'
      | 'errorMessage'
      | 'required'
      | 'error'
      | 'fullWidth'
      | 'inline'
    > {}

const RadioGroup = forwardRef(function RadioGroup(
  props: RadioGroupProps,
  ref: ForwardedRef<any>,
) {
  const {
    children,
    required,
    error,
    fullWidth,
    inline,
    label,
    helperText,
    errorMessage,
    ...radioGroupProps
  } = props;

  return (
    <FormFieldWrapper
      label={label}
      helperText={helperText}
      error={error}
      errorMessage={errorMessage}
      required={required}
      fullWidth={fullWidth}
      inline={inline}
      testId="radio-group"
    >
      <MuiRadioGroup {...radioGroupProps} ref={ref}>
        {children}
      </MuiRadioGroup>
    </FormFieldWrapper>
  );
});

export default RadioGroup;
